import { useField } from 'formik';
import * as React from 'react';
import { SignupActionSource } from '@journeyapps-platform/types-flight-log';
import { useEffect } from 'react';
import { usePrevious } from '../../hooks/usePrevious';
import { useSystem } from '../../hooks/useSystem';

export interface FlightLogInputProps {
  name: string;
  children?: JSX.Element;
}

/**
 * FlightLogInput will log an INVALID signup action when the validation error on the name'd field is set
 */
export const FlightLogInput: React.FC<FlightLogInputProps> = (props) => {
  const [field, meta] = useField(props.name);
  const previous = usePrevious(meta.error);
  const system = useSystem();

  useEffect(() => {
    if (!previous && meta.error && meta.touched) {
      system.flightLogger.logAction({ source: SignupActionSource.INPUT, action_id: `${props.name}: ${meta.error}` });
    }
  }, [previous, meta.error, meta.touched]);

  return props.children || null;
};
